// extracted by mini-css-extract-plugin
export default {"Footer":"Footer_Footer__MEpnh","Link":"Footer_Link__h5mti"};